import React from 'react';
import { Col, Row, Form, FormGroup } from 'react-bootstrap';

class CustomerData extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            customerData: this.props.customerData
        };
    }

    // Dataaccess behöver ändras här, stämmer inte med CS-klassen eftersom vi inte har info från NP vad som hämtas från csm
    render() {
        const data = this.state.customerData === undefined ? {} : this.state.customerData;
        return (
            <Col>
                <Form horizontal autoComplete="off" onSubmit={evt => { evt.preventDefault(); }}>
                    <FormGroup>
                        <Row className="row-eq-height">
                            <Col sm={4}>
                                <Row> <legend className="mylegend dataLegend">ACCOUNT INFORMATION</legend></Row>
                                <Row> <Col xs={4}>Company name:</Col><Col xs={8}>{data.COMPANY}</Col></Row>
                                <Row> <Col xs={4}>Company short name:</Col><Col xs={8}>{data.SHORT_NAME}</Col></Row>
                                <Row> <Col xs={4}>Customer no:</Col><Col xs={8}>{data.CLIENT_CODE_REGIONAL}</Col></Row>
                                <Row> <Col xs={4}>Sales rep:</Col><Col xs={8}>{data.REGION_DESCRIPTION}</Col></Row>
                                <Row> <Col xs={4}>Customer service specialist:</Col><Col xs={8}>{data.MARKET_DESCRIPTION}</Col></Row>
                                <Row> <Col xs={4}>Corporate group:</Col><Col xs={8}>{data.CLIENT_CODE_CORPORATE}</Col></Row>
                                <Row> <Col xs={4}>Agent:</Col><Col xs={8}>{data.SALES_AGENT_SHORT_NAME}</Col></Row>
                                <Row> <Col xs={4}>Agent:</Col><Col xs={8}>{data.SALES_AGENT_SHORT_NAME}</Col></Row>
                                <Row style={{paddingTop: '5px'}}>
                                    <Col xs={4}>Have access to Web portal:</Col>
                                    <Col xs={8}>
                                        <input type="checkbox" style={{marginTop: '-2px'}}
                                            disabled={true}
                                            checked={data.HasActiveUsers}>
                                        </input>
                                    </Col>
                                </Row>



                            </Col>

                            <Col sm={4} className="left-border">
                                <Row> <legend className="mylegend dataLegend">FINANCE</legend></Row>
                                <Row> <Col xs={4}>Credit limit:</Col><Col xs={8}>{data.CREDIT_LIMIT}</Col></Row>
                                <Row> <Col xs={4}>Terms of payment:</Col><Col xs={8}>{data.TERMS_OF_PAYMENT_DESC}</Col></Row>
                                <Row> <Col xs={4}>Currency:</Col><Col xs={8}>{data.CURRENCY_CODE}</Col></Row>

                            </Col>
                            <Col sm={4} className="left-border">
                                <Row> <legend className="mylegend dataLegend">DELIVERY INFORMATION</legend></Row>
                                <Row> <Col xs={4}>Delivery country:</Col><Col xs={8}>{data.COUNTRY_CODE}</Col></Row>
                                <Row> <Col xs={4}>Delivery region:</Col><Col xs={8}>{data.DELIVERY_REGION}</Col></Row>
                                <Row> <Col xs={4}>Delivery destination:</Col><Col xs={8}>{data.DELIVERY_DESTINATION}</Col></Row>
                                <Row> <Col xs={4}>Delivery terms:</Col><Col xs={8}>{data.DELIVERY_CODE}</Col></Row>
                            </Col>
                        </Row>
                    </FormGroup>
                </Form>
            </Col>
        )
    }
}

export default CustomerData;